import React from 'react';
import PropTypes from 'prop-types';
import withStyles, { css } from '@bd/bdui-styles';
import { userRegister } from '@bd/bdcore-data/build/User/actions';
import withData from '@bd/bdcore-data';

const defaultStyles = css``;

class ClientRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value,
    });
  }

  render() {
    const { className, dispatch } = this.props;

    return (
      <div className={className}>
        <form
          onSubmit={event => { event.preventDefault(); dispatch(userRegister(this.state)); }}
        >
          <div className="ClientRegister">
            <div className="ClientRegister_formSection">
              <h4 className="form-heading">Register</h4>
              <div className="form-group">
                <label htmlFor="registerEmail">Email</label>
                <input className="form-control" type="text" name="email" id="registerEmail" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input className="form-control" type="text" name="firstName" id="firstName" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input className="form-control" type="text" name="lastName" id="lastName" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="reigsterPassword">Password</label>
                <input className="form-control" type="password" name="password" id="reigsterPassword" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="password">Confirm Password</label>
                <input className="form-control" type="password" name="confirmPassword" id="confirmPassword" onChange={this.handleInput} required />
              </div>
              <button className="btn">Register</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

ClientRegister.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

ClientRegister.defaultProps = {
  className: undefined,
};

export default withData({})(withStyles(defaultStyles)(ClientRegister));



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ClientRegister.js